import React, { useState, useEffect } from "react";
import { db, ref, push, remove, update } from "config/Firebase";
import Alert from "utils/Alert";
import { useData } from "context/DataContext";

let valuesObject = {
  name: "",
  link: "",
};

const ClientLinks = () => {
  let [linkData, setLinkData] = useState([]);
  const [inputValues, setInputValues] = useState(valuesObject);
  let [isEdit, setIsEdit] = useState(null);
  const [alert, setAlert] = useState({ open: false, msg: "", type: "" });
  const [submitting, setSubmitting] = useState(false);
  const { clientLinkData } = useData();
  //   console.log(clientLinkData)

  useEffect(() => {
    setLinkData(clientLinkData);
  }, [clientLinkData]);

  const handleChange = (e) => {
    // console.log(e.target.value)
    setInputValues({ ...inputValues, [e.target.name]: e.target.value });
  };

  const handleSubmitProjectDetails = (e) => {
    e.preventDefault();
    setSubmitting(true);
    if (!isEdit) {
      push(ref(db, "clientsLink/"), {
        inputValues,
      })
        .then(() => {
          setSubmitting(false);
          setInputValues(valuesObject);
          setAlert({
            open: true,
            msg: "Data Save successfully.",
            type: "success",
          });
        })
        .catch((err) => {
          console.log(err);
          setSubmitting(false);
          setAlert({
            open: true,
            msg: "Something went wrong!",
            type: "error",
          });
        });
    } else {
      update(ref(db, `clientsLink/${isEdit}`), {
        inputValues,
      })
        .then(() => {
          setSubmitting(false);
          setInputValues(valuesObject);
          setIsEdit(null);
          setAlert({
            open: true,
            msg: "Data Updated successfully.",
            type: "success",
          });
        })
        .catch((err) => {
          console.log(err);
          setSubmitting(false);
          setAlert({
            open: true,
            msg: "Something went wrong!",
            type: "error",
          });
        });
    }
  };

  // delete project from database
  const handleDelete = (e) => {
    remove(ref(db, `clientsLink/${e}`))
      .then((res) => {
        setAlert({
          open: true,
          msg: "Data Deleted successfully.",
          type: "success",
        });
      })
      .catch((err) => {
        setAlert({ open: true, msg: "Something went wrong!", type: "error" });
      });
  };

  // edit project function
  const handleEdit = (event) => {
    // console.log(event);
    setInputValues(event.inputValues);
    setIsEdit(event.id);
  };

  const backToAddFOrm = () => {
    setInputValues(valuesObject);
    setIsEdit(null);
  };

  return (
    <div>
      <div>
        <div className="formBox">
          <form onSubmit={handleSubmitProjectDetails}>
            <div>
              <input
                type="text"
                placeholder="Web Title"
                name="name"
                onChange={handleChange}
                required
                value={inputValues.name}
              />
            </div>
            <br />
            <div>
              <input
                type="url"
                name="link"
                id="link"
                placeholder="Enter web url"
                required
                value={inputValues.link}
                onChange={handleChange}
              />
            </div>
            <br />
            <div className="cs_row justify-content-center align-items-center">
              {isEdit ? (
                <button type="button" onClick={backToAddFOrm}>
                  Cancel
                </button>
              ) : null}
              <button type="submit">
                {isEdit ? "Update Project" : "Add Project"}{" "}
              </button>
            </div>
          </form>
        </div>
        {/* <br /> */}
        <div className="tbSection">
          <table id="customers">
            <thead>
              <tr>
                <th>S.no</th>
                {/* <th></th> */}
                <th>Name</th>
                <th>Link</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {linkData.length > 0
                ? linkData.map((val, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{val.inputValues.name}</td>
                      <td id="links">
                        <a
                          href={val.inputValues.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {val.inputValues.link}
                        </a>{" "}
                      </td>
                      <td className="cs_row .flex-wrap align-items-center justify-content-center">
                        <button
                          onClick={() => handleDelete(val.id)}
                          className="my-2"
                        >
                          &#10060;
                        </button>{" "}
                        <button
                          onClick={() => handleEdit(val)}
                          className="my-2"
                        >
                          &#9998;
                        </button>
                      </td>
                    </tr>
                  ))
                : null}
            </tbody>
          </table>
        </div>
      </div>
      <Alert data={alert} setAlert={setAlert} />
    </div>
  );
};

export default ClientLinks;
